module.exports = __webpack_public_path__ + "341d1e2ca42ed5f3.svg";